/**
 * @fileoverview Очки, серия, критические нарушения.
 */

import { MAX_VIOL } from "../constants/world";
import { Snd } from "../audio/sound";
import type { GameHooks, GameState, Plane } from "../state/types";

/** Начислить / списать очки (с учетом множителя серии для плюсов). */
export function addScore(
  g: GameState,
  hooks: GameHooks,
  v: number,
  p: Plane | null,
  label: string | null,
): void {
  const val = v > 0 ? Math.round(v * g.mult) : Math.round(v);
  g.score = Math.max(0, g.score + val);
  if (label) {
    if (!g.scoreLog) g.scoreLog = [];
    g.scoreLog.push({ v: val, label, t: g.elapsed });
    if (g.scoreLog.length > 48) g.scoreLog.shift();
  }
  if (p) {
    hooks.fx(
      p.x,
      p.y - 30,
      `${val > 0 ? "+" : ""}${val}${label ? `  ${label}` : ""}`,
      val > 0 ? "#7ee08a" : "#ff6b6b",
    );
  } else if (label) {
    hooks.fx(
      800,
      480,
      `${val > 0 ? "+" : ""}${val}  ${label}`,
      val > 0 ? "#7ee08a" : "#ff6b6b",
    );
  }
  hooks.onScoreChanged?.(g.score);
}

/** Увеличить серию и множитель. */
export function bumpStreak(g: GameState, hooks: GameHooks): void {
  g.streak++;
  g.bestStreak = Math.max(g.bestStreak, g.streak);
  g.mult = Math.min(4, 1 + Math.floor(g.streak / 3) * 0.5);
  if (g.streak > 0 && g.streak % 3 === 0) {
    hooks.toast(`Серия ${g.streak} — множитель ×${g.mult.toFixed(1)}`, "good");
    Snd.tone(880, 0.12, "triangle", 0.09);
  }
}

/** Сбросить серию. */
export function breakStreak(g: GameState, hooks: GameHooks): void {
  if (g.streak > 2) hooks.toast("Серия прервана", "bad");
  g.streak = 0;
  g.mult = 1;
}

/** Зафиксировать критическое нарушение (лимит MAX_VIOL). */
export function violation(
  g: GameState,
  hooks: GameHooks,
  text: string,
): void {
  if (g.over) return;
  g.violations++;
  breakStreak(g, hooks);
  addScore(g, hooks, -100, null, null);
  g.worstMistake = text;
  hooks.toast(`НАРУШЕНИЕ: ${text}`, "bad");
  Snd.bad();
  g.flash = 0.9;
  if (g.violations >= MAX_VIOL) {
    hooks.endGame(
      "Смена прервана",
      "Три критических нарушения — вас отстранили от смены.",
    );
  }
}
